var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3746 9.97073L19.3746 2.97073C19.2013 2.77073 18.9346 2.66406 18.668 2.66406H8.66797C7.5613 2.66406 6.66797 3.5574 6.66797 4.66406V28.6641C6.66797 29.7707 7.5613 30.6641 8.66797 30.6641H24.668C25.7746 30.6641 26.668 29.7707 26.668 28.6641V10.6641C26.668 10.3974 26.5613 10.1441 26.3746 9.97073ZM18.668 5.06406L24.268 10.6641H18.668V5.06406ZM24.668 28.6641H8.66797V4.66406H16.668V10.6641C16.668 11.7707 17.5613 12.6641 18.668 12.6641H24.668V28.6641Z",
    fill: "#99A1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic-file.4fdc5d22d234621e5169cf8a2c9ae1fb.svg";
export { ForwardRef as ReactComponent };